module.exports = __webpack_public_path__ + "img/section-judging-submission.b6d6ba17.png";